import type { App, Component, Plugin } from 'vue';

import IufAvatar from './iuf-avatar/iuf-avatar.vue';

type Components = Record<string, Component>;

const uiComponents: Components = { IufAvatar };

export const LegacyComponents: Plugin = {
    install(app: App, options = {}) {
        const componentNames = Object.keys(uiComponents);
        for (const name of componentNames) {
            app.component(name, uiComponents[name]);
        }
    }
};
